import React from 'react';
import { Globe } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12 mb-12">
          {/* Brand */}
          <div className="max-w-md">
            <a href="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_b286a459-1ebd-49cc-9e3f-46880bb89d86/artifacts/1zkgq9wl_Tappollo_icon.png" 
                alt="Fundability.ai" 
                className="w-10 h-10 rounded-lg object-contain"
              />
              <div className="flex flex-col">
                <span className="text-white font-semibold text-xl leading-tight">Fundability.ai</span>
                <span className="text-white/50 text-xs">by Tappollo</span>
              </div>
            </a>
            <p className="text-white/50 max-w-sm mb-6 leading-relaxed">
              Helping non-technical founders transform their ideas into investible startups. 
              We are the tech partner, co-founder, CTO that you have been looking for.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/tappollo-media"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.tappollo.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <Globe className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} Fundability.ai by Tappollo Media. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/privacy" className="text-white/40 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="text-white/40 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;